

import React from 'react';
import { connect } from 'react-redux';
import { FaCheckCircle } from 'react-icons/fa';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import SignUpComponent from './SignUpComponent';

class BillPayTransactionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verified: false,
            siteKey: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    onVerify = recaptchaResponse => {
        this.setState({
            verified: true
        });
    };

    fetchAccountDetails() {

        if (ValidateForm.inputFieldMandatoryCheck("otpCustomerIdContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("otpCustomerIdContainer", this.props.locales, false)) {
                this.props.setLoginPage("pageName", "amountForBillPay");
            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.billPaymentComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    billPaymentComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="col-md-12 row pt-5 m-0 mt-5">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2 mt-5" id="otpCustomerIdContainer">
                        <div className="col-md-9 text-center"><FaCheckCircle color="#7ED321" size="50" /></div>
                        <div className="col-md-12 pt-3" style={{ fontSize: 30, color: '#404042', fontWeight: 600 }}>{this.props.locales.transactionSuccessMsgInLoinPart}</div>
                        <div className="col-md-12 pt-3" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.amountOfMsgInLoginPart}{this.props.userRegisterDetails.accountDetails.amount} {this.props.locales.hasBeenPaidMsgInLoginPart} {this.props.userRegisterDetails.accountDetails.billingName} ({this.props.userRegisterDetails.accountDetails.accountId})</div>
                        <div className="col-md-12 pt-3" style={{ fontSize: 18, color: '#404042', fontWeight: 600 }}>{this.props.locales.transactionIdInBillPaymentPart} : {this.props.userRegisterDetails.accountDetails.transactionId}</div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    signInLinkClicked() {
        this.props.setLoginPage("pageName", "customerIdForOTP");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        siteKey: state.siteKey,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const BillPayTransactionComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(BillPayTransactionComponent)


export default BillPayTransactionComponentContainer;